import { 
  ConfigurationModel, 
  ConfigurationValidationPartState,
  ConfigurationItemType,
  ValidationItem,
  ConfigurationValidationByItem,
} from 'franke-trough-dependencies';

import { RequestApiError } from 'loopback-react-request';

export enum SelectedTroughKeys {
  Qty = 'qty',
  Trough = 'trough',
}

export enum  WashBasinDimensionKeys {
  TypeOfInstallation = 'typeOfInstallation',
  AngleOfNiche = 'angleOfNiche',
  CornerDesign = 'cornerDesign',
  CornerDesignPosition = 'cornerDesignPosition',
  PlateDimensions = 'plateDimensions',
  Distances = 'distances',
}

export enum ApronBackSplashKeys {
  Apron = 'apron',
  ApronHeight = 'apronHeight',
  SurgeEdgeOrBackSplash = 'surgeEdgeOrBackSplash',
  PositionOfEdgeOrBacksplash = 'positionOfEdgeOrBacksplash',
  BacksplashHeight = 'backsplashHeight',
}

export enum BuiltInPartsKeys {
  TapHole = 'tapHole',
  TapHolePositions = 'tapHolePositions',
  SoapDispenserHole = 'tapHolePositions',
  SoapDispenserHolePositions = 'soapDispenserHolePositions',
  WithPaperTowelDispensers = 'withCutOutDisposals',
  WithPaperTowelDispensersPosition = 'withCutOutDisposalsPosition',
  WithPaperTowelDispensersType = 'withCutOutDisposalsType',
  WithTissueDispenser = 'withTissueDispenser',
  WithTissueDispenserPosition = 'withTissueDispenserPosition',
  TowelRail = 'towelRail',
  TowelRailPosition = 'towelRailPosition',
}

export enum PlateSurfaceKeys {
  Color = 'color',
  GelCoat = 'gelCoat',
}

export enum AssemblyAccessoriesKeys {
  Selection = 'selection',
  Console = 'console',
}

export enum DrainAccessoriesKeys {
  Drain = 'drain',
  Siphon = 'siphon',
}

export type ConfigurationKeys = SelectedTroughKeys | WashBasinDimensionKeys |
   ApronBackSplashKeys | BuiltInPartsKeys | PlateSurfaceKeys | 
   AssemblyAccessoriesKeys | DrainAccessoriesKeys;

export enum NavigationConfigurationKeys {
  selectedTrough = 'selectedTrough',
  washBasinDimension = 'washBasinDimension',
  apronBackSplash = 'apronBackSplash',
  builtInParts = 'builtInParts',
  surface = 'surface',
  assemblyAccessories = 'assemblyAccessories',
  drainAccessories = 'drainAccessories',
}

  
export const navigationConfigurationKeys: NavigationConfigurationKeys[] = [
  NavigationConfigurationKeys.selectedTrough,
  NavigationConfigurationKeys.washBasinDimension,
  NavigationConfigurationKeys.apronBackSplash,
  NavigationConfigurationKeys.builtInParts,
  NavigationConfigurationKeys.surface,
  NavigationConfigurationKeys.assemblyAccessories,
  NavigationConfigurationKeys.drainAccessories,
];

export const splitErrorCode = (msg: string): string[] | undefined => {
  let splitMsg: string[] | undefined;
  if (msg && msg.indexOf('|') > -1) {
    splitMsg = msg.split('|');
  } else {
    return;
  }
  if (splitMsg && splitMsg.length === 0) {
    return;
  }
  return splitMsg;
};

export const getErrorObjectFromCode = (msg: string): string[] | undefined => {
  let splitMsg = splitErrorCode(msg);
  if (!splitMsg) {
    return;
  }
  const errorObjectsString = splitMsg[0];
  if (errorObjectsString.indexOf('.') > -1) {
    return errorObjectsString.split('.');
  }
  return [errorObjectsString];
};

export const getCodeFromError = (msg: string): string | undefined => {
  let splitMsg = splitErrorCode(msg);
  if (!splitMsg) {
    return;
  }
  return splitMsg[splitMsg.length - 1];
};

export const validateConfigurationByPart = (
  keys: NavigationConfigurationKeys[] = navigationConfigurationKeys, 
  configuration: ConfigurationModel,
  error?: RequestApiError
): ConfigurationValidationPartState => {
  const parts = {};
  const errorsInObjects = error && getErrorObjectFromCode(error.code);

  keys.map(key => {
    const confItem = configuration[key];
    parts[key] = false;
    if (confItem && confItem !== null) {
      if (errorsInObjects && errorsInObjects.indexOf(key) > -1) {
        parts[key] = false;
      } else {
        parts[key] = true;
      }
    }
  });
  return parts as ConfigurationValidationPartState;
};

export const validateConfigurationBPartByItem = (
  confItem: ConfigurationItemType, 
  errorArr: string[],
  error?: RequestApiError
): {[key: string]: ValidationItem} => {
  const keys = Object.keys(confItem);
  const item = {};
  if (keys && keys.length > 0) {
    keys.map(key => {
      const hasError = errorArr && errorArr.indexOf(key) > -1 ? true : false;
      item[key] = confItem[key] && hasError ? {
          code: error && getCodeFromError(error.code),
          message: error && error.message,
          hasError
        } : false;
    });
  }
  return item as {[key: string]: ValidationItem};
};

export const validateConfigurationByItem = (
  keys: NavigationConfigurationKeys[] = navigationConfigurationKeys, 
  configuration: ConfigurationModel,
  error?: RequestApiError
): ConfigurationValidationByItem | undefined => {
  const parts = {};
  const errorsInObjects = error && getErrorObjectFromCode(error.code);
  keys.map(key => {
    const confItem = configuration[key];
    const hasError = errorsInObjects && errorsInObjects.indexOf(key) > -1 ? true : false;
    if (hasError && confItem && errorsInObjects) {
      parts[key] = validateConfigurationBPartByItem(confItem, errorsInObjects, error);
    } else {
      parts[key] = undefined;
    }
  });
  return parts;
};

export const disableConfigurationParts = (validated: ConfigurationValidationPartState): ConfigurationValidationPartState => {
  const disabled = {};
  const keys = Object.keys(validated);
  keys.map((key, index) => {
    if (index === 0) {
      disabled[key] = false;
    } else {
      const prevKey = keys[index - 1];
      disabled[key] = !validated[prevKey];
    }
  });
  return disabled as ConfigurationValidationPartState;
};